import { MouseEventHandler } from 'react';
import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

const StyledPauseIcon = styled(StyledFlex)`
   cursor: pointer;
`;

type PauseIconProps = { onClick: MouseEventHandler };

export const PauseIcon = (props: PauseIconProps): JSX.Element => (
   <StyledPauseIcon onClick={props.onClick}>
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <rect x='1' y='1' width='30' height='30' rx='15' stroke='#589AE9' strokeWidth='2' />
         <path d='M11.5 21H14.1667V11H11.5V21ZM17.8333 21H20.5V11H17.8333V21Z' fill='#589AE9' />
      </svg>
   </StyledPauseIcon>
);
